import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { ROW_TONE } from './listingCardRows';

import css from './ListingStatusRows.module.css';

const TONE_CLASS = {
  [ROW_TONE.POSITIVE]: css.dotPositive,
  [ROW_TONE.WARNING]: css.dotWarning,
  [ROW_TONE.NEGATIVE]: css.dotNegative,
  [ROW_TONE.NEUTRAL]: css.dotNeutral,
};

/**
 * A status is something you read; an action is something you open.
 *
 * These rows used to be two dropdowns and a text-styled button. They are now plain
 * text with a coloured dot: never clickable, never blue, no chevron. The dot carries
 * the tone so the text does not have to be coloured, which is what made the old
 * subscription value look like a link to some sellers and like nothing at all to
 * others.
 */
const StatusRow = ({ labelId, row, values }) => {
  if (!row) {
    return null;
  }

  return (
    <div className={css.row}>
      <span className={css.label}>
        <FormattedMessage id={labelId} />
      </span>
      <span className={classNames(css.dot, TONE_CLASS[row.tone] || css.dotNeutral)} />
      <span className={css.value}>
        <FormattedMessage id={row.valueId} values={values} />
      </span>
    </div>
  );
};

/**
 * @param {Object} props
 * @param {Object} props.rows output of deriveStatusRows()
 * @param {string} [props.advertisementDate] formatted date for the advertisement row
 * @param {string} [props.subscriptionDate] formatted date for the subscription row
 * @param {ReactNode} [props.planLabel] e.g. "13 weken", when the row asks for it
 */
const ListingStatusRows = props => {
  const { rows, advertisementDate, subscriptionDate, planLabel, className } = props;

  if (!rows) {
    return null;
  }

  const { advertisement, subscription, noteId } = rows;

  return (
    <div className={classNames(css.root, className)}>
      <StatusRow
        labelId="ListingStatusRows.label.advertisement"
        row={advertisement}
        values={{ date: advertisementDate }}
      />
      <StatusRow
        labelId="ListingStatusRows.label.subscription"
        row={subscription}
        values={{ date: subscriptionDate, plan: planLabel }}
      />
      {/* A sentence, for consequences a row value cannot carry on its own — such as
          what happens to the advertisement after the cancellation date. */}
      {noteId ? (
        <p className={css.note}>
          <FormattedMessage id={noteId} values={{ date: subscriptionDate }} />
        </p>
      ) : null}
    </div>
  );
};

export default ListingStatusRows;
